<!-- 违背原因列表 -->
<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      close-icon="close"
      :close-on-popstate="true"
      closeable
      round
      :get-container="getContainer"
      :style="{ bottom: bottom }"
    >
      <div class="violateList full-height">
        <div>
          <div>
            <van-sticky>
              <ld-header
                title="选择违背原因"
                @click-left="addlist"
              />
            </van-sticky>
            <div class="pad8">
              根据贵公司政策规定，您当前违背了
            </div>
            <van-row
              type="flex"
              align="center"
            >
              <van-col :span="1" />
              <van-col :span="1">
                <div class="cicle" />
              </van-col>
              <van-col
                class="gray font12 pad8"
                :span="22"
              >
                <span v-if="violate && violate.violateItem">{{ violate.violateItem }}</span>
                <span v-else>{{ violate }}</span>
              </van-col>
            </van-row>
          </div>
          <div class="violatewrapper">
            <mescroll-vue
              ref="mescroll"
              :down="down"
            >
              <van-radio-group
                v-model="checked"
              >
                <van-cell-group>
                  <van-cell
                    v-for="(info, index) in list"
                    :key="index"
                    @click="checked = info.reasonCode"
                    :class="{ 'selected-row': checked === info.reasonCode }"
                  >
                    <span
                      slot="title"
                      v-if="info.reasonCode == 'QT'"
                    >
                      {{ info.reasonLabel }}
                    </span>
                    <span
                      slot="title"
                      v-else
                    >
                      {{ info.reasonDesc }}
                    </span>
                    <van-radio
                      slot="right-icon"
                      :name="info.reasonCode"
                    />
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <van-field
                v-show="checkedObj.reasonCode == 'QT'"
                v-model="checkedObj.reasonDesc"
                placeholder="请输入其它原因"
              />
            </mescroll-vue>
          </div>
        </div>
      </div>

      <div
        class="pad8 sticky-footer"
      >
        <ld-button
          main
          size="lg"
          @click.native="toEdit"
        >
          {{ $t('B006', '确定') }}
        </ld-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldButton from 'Common/ldButton'

import {Popup, Cell, RadioGroup, Radio, Field, CellGroup, List, Sticky} from 'vant'

const QT = {
  reasonCode: 'QT',
  reasonLabel: '其它原因',
  reasonDesc: ''
}

export default {
  name: 'ViolateList',
  components: {
    MescrollVue,
    ldButton,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [List.name]: List,
    [Sticky.name]: Sticky
  },
  props: {
    violate: {// 违背政策
      type: [Array, String , Object],
      default:() => {}
    },
    cplx: {// 产品类型，请求对应违背列表
      type: String,
      default: '10901'
    },
    element:{
      type: String,
      default: ''
    },
    bottom:{
      type: String,
      default: '0px'
    }
  },
  data() {
    return {
      checked: '',
      checkedObj:{},//选中值
      list: [],//列表
      isShow: false,
      reasonCode: '',
      reasonDesc: '',
      cplxObj: { // 根据产品缓存
        '11601035': 'tk',
        '10901': 'tk',
        '10902': 'tkInt',
        '10904': 'tr',
        '10903': 'ht',
        '10906': 'car',
        '10913': 'visa'
      },
      down: {use: false},
      showButton: false,
    }
  },
  methods: {
    addlist() {
      this.isShow = false
    },
    toEdit() {
      if (this.checkedObj.reasonCode == QT.reasonCode) {
        if (!this.checkedObj.reasonDesc) {
          this.$toast('请填写其他原因')
          return
        }
      }
      let obj = {}
      if (typeof this.violate === 'string') {
        obj = this.checkedObj
      } else {
        obj = Object.assign({}, this.violate, this.checkedObj)
      }
      this.$store.commit(`${this.cplxObj[this.cplx]}/SET_VIOLATELIST`, obj)
      this.$emit('update:violate', obj)
      this.$emit('selected', obj)
      this.isShow = false
    },
    getList() {
      let params = {}
      if (this.cplx) params = { by1: this.cplx }
      this.$api['common/violateReasonList'](params).then(res => {
        let cache = res.data || {}
        cache.push(QT)
        this.list = cache || []
        if(typeof this.violate === 'object' && this.violate.reasonCode){
          this.checked = this.violate.reasonCode
        }else{
          this.checked = this.list[0].reasonCode
        }
      })
    },
    // 违背原因
    getWbyyList() {
      let params = {}
      // if (this.cplx) params = {parNo: '11601035'}
      if (this.cplx) params = {parNo: '11601035'}
      // 后端开发让换接口了
      // this.$api['common/violateReasonList'](params).then(res => {
      this.$api['common/getVipBClass'](params).then(res => {
        let cache = res.data.list || {}
        cache.push(QT)
        this.list = cache || []
        if (typeof this.violate === 'object' && this.violate.reasonCode) {
          this.checked = this.violate.reasonCode
        } else {
          this.checked = this.list[0].reasonCode
        }
      })
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if(this.isShow){
        if(obj){
          Object.assign(this,obj)
        }
        this.getList()
      }
    },
    // 违背原因
    wbyy() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.getWbyyList()
      }
    },
  },
  watch: {
    checked(val) {
      if (this.list.length > 0) {
        this.checkedObj = this.list.find(item => {
          return item.reasonCode == val
        })
      }
    }
  }
}
</script>

<style  lang="less" scoped>
.violateList {
  .violatewrapper {
    background-color: @color-background-white;
    overflow: hidden;
  }

  .pad8 {
    padding: 8px;
  }

  .cicle {
    width: 7px;
    height: 7px;
    margin-right: 10px;
    border-radius: 50%;
    background: @color-text-red;
  }
}

.selected-row {
  background-color: #f0f0f0; /* 设置选中行的背景颜色 */
}

.fixed-bottom {
  position: fixed;
  bottom: 0px;
  right: 5px;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  padding: 3px;
}


</style>
